import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import BlockSection from '~/components/wrappers/BlockSection';

import AccordionGroup from '~/components/AccordionGroup';

import { h3 } from '~/styles/typography';
import { setSmallSpacing } from '~/utilities/spacing';
import { formatText } from '~/utilities/helpers';

import {
    GlobalBlockOptions,
    AcfAttributes,
    DefaultGlobalBlockOptions,
    DefaultAcfAttributes
} from '~/utilities/propTypes';

const Title = styled.h2`
    ${h3};
    text-transform: uppercase;
    text-align: center;
    ${setSmallSpacing('margin-bottom')};

    @media (min-width: ${({ theme }) => theme.breakpoint.largeTablet}) {
        font-size: 3rem;
    }
`;

const Accordions = ({
    title = '',
    accordions,
    globalBlockOptions = DefaultGlobalBlockOptions,
    attributes = DefaultAcfAttributes
}) => {
    return (
        <BlockSection {...{ globalBlockOptions, attributes }}>
            {title ? <Title>{formatText(title)}</Title> : null}
            <AccordionGroup {...{ accordions }} />
        </BlockSection>
    );
};

Accordions.propTypes = {
    title: PropTypes.string,
    accordions: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string.isRequired,
            content: PropTypes.string.isRequired
        })
    ).isRequired,
    globalBlockOptions: GlobalBlockOptions,
    attributes: AcfAttributes
};

export default Accordions;
